<template>
    <rkm-area
        no-margin-top
        title="Motivo do atendimento"
    >
        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => `${item.ciap.codigo} - ${item.ciap.descricao}`"
                    label="CIAP"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.motivoAtendimento">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.motivoAtendimento"
                    label="Motivo do atendimento"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>